// extracted by mini-css-extract-plugin
export default {"submitBtn":"style__submitBtn___wqXem","submitBtnOnPage":"style__submitBtnOnPage___khVAm","submitInput":"style__submitInput___QqHWY","submitLabel":"style__submitLabel___Ci_A0"};